/* eslint-disable */

import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer, DefaultRenderer } from '@googlemaps/markerclusterer';  // Use MarkerClusterer v2.x
import { Modal } from 'bootstrap'

// fatalities for the map, set in the craft templates eg: online-collections/types/oralHistoriesLanding etc
const fatalities = window.fatalities;
console.log(fatalities);
// Coordinates and zoom set in craft templates
const startLat = window.startLat;
const startLong = window.startLong;
const zoom = window.zoom;
let lazySettings = window.lazy_settings;
let featuredSettings = {};
featuredSettings['templatePath'] = 'online-collections/types/featured-fatalities/fatality.twig';
featuredSettings['variableName'] = 'operation';
var county = '';
var operation = '';
var title = '';
var organisation = '';
var civilwar = false;
var execution = false;
let ajaxTable = document.querySelector('.fatalitiesTable');
let featuredContainer = document.querySelector('.featuredContainer');
let loadMoreButton = document.querySelector('.js-load-more');
let currentRequest = null,
    notAllDisplayed = true;
let lazyOffset = 1;

const ready = (func) => {
  if (document.readyState !== 'loading') {
      func();
  } else {
      document.addEventListener('DOMContentLoaded', func);
  }
};

console.log(lazySettings);

const loader = new Loader({
  // Military archives google API key
  apiKey: "AIzaSyCHYhJW-qzt0jzzBm0LRhvnsGUknmzNEEE",
  version: "weekly",
  libraries: ['marker']  // Keep 'marker' library for handling markers
});

// Custom Renderer for cluster icons
class CustomClusterRenderer extends DefaultRenderer {
  render({ count, position }) {

    // Colours for different cluster sizes
    let color;
    if (count < 10) {
      color = '#191919'; 
    } else if (count < 50) {
      color = '#191919'; 
    } else {
      color = '#191919';
    }

    // Create a custom SVG icon with the selected color
    const svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <circle cx="20" cy="20" r="20" fill="${color}" />
        <text x="20" y="25" text-anchor="middle" font-size="12" font-family="Arial" fill="white">${count}</text>
      </svg>
    `);

    // Return a custom cluster icon with the colored SVG
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(40, 40),  // Size of the icon
      },
      label: {
        text: String(count),  // Number of markers in the cluster
        color: 'white',       // Color of the text inside the cluster
        fontSize: '12px',     // Text font size
      },
      zIndex: google.maps.Marker.MAX_ZINDEX + count,  // Ensure clusters appear on top
    });
  }
}

// Load the Maps API
loader.load().then(() => {
  const mapOptions = {
    center: { lat: startLat, lng: startLong },
    zoom: zoom,
    mapId: 'a18a7ca9a3d91770',
    disableDefaultUI: true,
    zoomControl: true
  };
  
  loader.importLibrary('maps').then(({ Map }) => {
    const map = new Map(document.getElementById("fatalitymap"), mapOptions);
    
    //The map pin is generated as svg, color, shape and scale set here

  const pinProSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="42" height="55" viewBox="0 0 42 55" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd"
        d="M21 0C32.598 0 42 9.40202 42 21C42 22.4157 41.8599 23.7986 41.5929 25.1358C39.7394 39.1032 21.1104 55 21.1104 55C21.1104 55 5.25689 41.4717 1.34456 28.4096C0.475507 26.1054 0 23.6083 0 21C0 9.40202 9.40202 0 21 0Z"
        fill="black"/>
  <path d="M29 21C29 16.5817 25.4183 13 21 13C16.5817 13 13 16.5817 13 21C13 25.4183 16.5817 29 21 29C25.4183 29 29 25.4183 29 21Z"
        fill="white"/>
  <circle cx="21" cy="22" r="15" fill="black" stroke="white" stroke-width="2"/>
</svg>
`.trim();
    const mapPinPro = {
        url:
            'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(pinProSvg),
        scaledSize: new google.maps.Size(21, 27), // match your SVG size
        anchor: new google.maps.Point(10.5, 27), // tip at bottom center
    };

    const pinAntiSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="42" height="55" viewBox="0 0 42 55" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21 0C32.598 0 42 9.40202 42 21C42 22.4157 41.8599 23.7986 41.5929 25.1358C39.7394 39.1032 21.1104 55 21.1104 55C21.1104 55 5.25689 41.4717 1.34456 28.4096C0.475507 26.1054 0 23.6083 0 21C0 9.40202 9.40202 0 21 0Z" fill="black"/>
  <path d="M29 21C29 16.5817 25.4183 13 21 13C16.5817 13 13 16.5817 13 21C13 25.4183 16.5817 29 21 29C25.4183 29 29 25.4183 29 21Z" fill="white"/>
  <circle cx="21" cy="22" r="15" fill="black" stroke="white" stroke-width="2"/>
  <line x1="10.845" y1="11.4653" x2="31.5347" y2="32.155" stroke="white" stroke-width="2"/>
</svg>
`.trim();

    const mapPinAnti = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(pinAntiSvg),
        scaledSize: new google.maps.Size(21, 27), // match your SVG size
        anchor: new google.maps.Point(10.5, 27), // tip at bottom center
    };

    // const mapPinAnti = {
    //     path: 'M7 0C3.13 0 0 3.13 0 7C0 8.74 0.5 10.37 1.41 11.84C2.36 13.38 3.61 14.7 4.57 16.24C5.04 16.99 5.38 17.69 5.74 18.5C6 19.05 6.21 20 7 20C7.79 20 8 19.05 8.25 18.5C8.62 17.69 8.95 16.99 9.42 16.24C10.38 14.71 11.63 13.39 12.58 11.84C13.5 10.37 14 8.74 14 7C14 3.13 10.87 0 7 0ZM7 9.75C5.62 9.75 4.5 8.63 4.5 7.25C4.5 5.87 5.62 4.75 7 4.75C8.38 4.75 9.5 5.87 9.5 7.25C9.5 8.63 8.38 9.75 7 9.75Z',
    //     strokeColor: '#4cbeb9ff',
    //     fillColor: '#42b151ff',
    //     fillOpacity: 1,
    //     scale: 1.1,
    // };

       const pinNeutralSvg = `
<svg width="42" height="55" viewBox="0 0 42 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 0C32.598 0 42 9.40202 42 21C42 22.4157 41.8599 23.7986 41.5929 25.1358C39.7394 39.1032 21.1104 55 21.1104 55C21.1104 55 5.25689 41.4717 1.34456 28.4096C0.475507 26.1054 0 23.6083 0 21C0 9.40202 9.40202 0 21 0Z" fill="black"/>
<path d="M29 21C29 16.5817 25.4183 13 21 13C16.5817 13 13 16.5817 13 21C13 25.4183 16.5817 29 21 29C25.4183 29 29 25.4183 29 21Z" fill="white"/>
<circle cx="21" cy="22" r="15" fill="black"/>
</svg>

`.trim();


    const mapPinNeutral = {
        url:
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(pinNeutralSvg),
        scaledSize: new google.maps.Size(21, 27), // match your SVG size
        anchor: new google.maps.Point(10.5, 27), // tip at bottom center
    };

    let markerCluster = null;
    let refreshMarkerCluster = null;
    let markers = [];
    const bounds = new google.maps.LatLngBounds(); // Create LatLngBounds object

    const executionsModal = new Modal(document.getElementById('executionsModal'));
    const closeModalBtn = document.getElementById('closeModalBtn');
          

    $(".county-dropdown").on("change", function() {
      county = $(this).val();
      filterMarkers(organisation, execution, county);
      filterTable(organisation, execution, county);
      $('.county-dropdown').val(county);
    });

    $(".organisation-dropdown").on("change", function() {
      organisation = $(this).val();
      console.log(organisation);
      filterMarkers(organisation, execution, county);
      filterTable(organisation, execution, county);
      $('.organisation-dropdown').val(organisation);
    });

    $(".execution").on("change", function() {
      console.log("execution change");
      var isChecked = $(this).is(':checked');
      $('.execution').prop('checked', isChecked);
      if ($(this).is(':checked')) {
        if ($(this).hasClass('civil-war-executions-js')) {
        executionsModal.show();
        }
        execution = true;
      } else {
        execution = false;
      }
      console.log(execution);
      filterMarkers(organisation, execution, county);
      filterTable(organisation, execution, county);
    });

    $("#fatality").keyup(function() {
      title = $(this).val();
      console.log(title);      
      filterTable(organisation, execution, county, title);      
    });
    
    function filterMarkers(organisation, execution, county) {
      const updatedfatalities = [];
      $.ajax({
        url: '/map-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county, 
          execution: execution,      
          organisation: organisation,      
          settings: lazySettings
          //executions   
        }, // Pass the selected filter
        success: function(response) {
          // Assuming the server returns a list of fatalities similar to the initial `fatalities`

          clearMarkersAndClusters();

          response.data.forEach(item => {
            //console.log(item.title);  // Outputs each title to the console
    
          });
          
          response.data.forEach(item => {
    
            const info = '<a href="' + item.url + '"><h3>' + item.title + '</h3></a>'
    
            updatedfatalities.push({
              position: {
                lat: item.latitude,
                lng: item.longitude
              },
              label: item.title,
              title: item.tite,
              url: item.url,
              info: info
            });
          });
    
          updateMarkers(updatedfatalities);              
    
          //updateMarkers(response.fatalities); // Update markers based on the response
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

    function filterTable(organisation, execution, county, title) {
      lazyOffset = 1;
      notAllDisplayed = true;

      $.ajax({
        url: '/table-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county,   
          title: title,
          execution: execution,
          organisation: organisation,
          settings: lazySettings,   
        }, // Pass the selected filter
        success: function(response) {
          console.log("empty table");
          console.log(response.data.length);
          if (response.data.length > 29) {
            loadMoreButton.style.display = 'block'; 
          }
          ajaxTable.innerHTML = "";
          let table = '';
          response.data.forEach(item => {
            table += item.html;
          });
          ajaxTable.innerHTML += table;
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }
    
    function filterFeatured(county) {
      $.ajax({
        url: '/featured-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county,          
          settings: featuredSettings,   
        }, // Pass the selected filter
        success: function(response) {
          featuredContainer.innerHTML = "";
          let list = '';
          response.data.forEach(item => {
            list += item.html;
          });
          featuredContainer.innerHTML += list;
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

    function clearMarkersAndClusters() {
      // Clear each marker by setting its map to null

      markers.forEach(marker => marker.setMap(null));

      // Clear the markers array
      markers = [];

      // If a MarkerClusterer instance exists, clear the clusters and markers
      if (refreshMarkerCluster) {

        refreshMarkerCluster.setMap(null);
        refreshMarkerCluster.clearMarkers();
          // Clear the clusters
        refreshMarkerCluster = null;  // Reset the markerCluster instance
      } 
      if (markerCluster) {

        markerCluster.setMap(null);
        markerCluster.clearMarkers();  // Clear the clusters
          // Clear the clusters
        markerCluster = null;  // Reset the markerCluster instance
      }  else {

      }
    } 

    var oldValue = 0
    var newValue = 0

    ready(() => {

      $(".js-load-more").click(function() {
          
          if (currentRequest === null && notAllDisplayed === true) {

              loadMoreButton.style.display = 'block';              

              currentRequest = $.ajax({
                  url: '/table-load-more',
                  method: 'GET',
                  data: {
                      offset: lazyOffset,
                      county: county,   
                      organisation: organisation,
                      execution: execution,
                      settings: lazySettings,   
                  },
                  beforeSend: () => {
                      //lazyPreloader.style.display = 'block';
                  },
              })
              .always(() => {
                  //lazyPreloader.style.display = 'none';
                  currentRequest = null;
              })
              .done((returned) => {
                  lazyOffset++;
                  let html = '';
                  returned.data.forEach((element) => {                                            
                      html += element.html;
                  });        
                  ajaxTable.innerHTML += html;
                  if (!returned.data.length) {
                      notAllDisplayed = false;
                      loadMoreButton.style.display = 'none'; 
                  }
                  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                      return new bootstrap.Tooltip(tooltipTriggerEl)
                  })
              })
              .fail(() => {
                  errorMessage.textContent = 'Unable to retrieve articles.';
              });
          }
          //oldValue = newValue;

        });
     
    });

    function updateTable(fatalities) {
      lazyOffset = 1;
      notAllDisplayed = true;
      $.ajax({
        url: '/table-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          settings: lazySettings,   
        }, // Pass the selected filter
        success: function(response) {
          ajaxTable.innerHTML = "";
          let table = '';
          response.data.forEach(item => {
            table += item.html;
          });
          ajaxTable.innerHTML += table;
          loadMoreButton.style.display = 'block';
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    };

    function updateMarkers(fatalities) {

      console.log('updating');

      //markers = [];  // Reset the markers array         
      refreshMarkerCluster = new MarkerClusterer({
        map: map,
        markers: markers,
        renderer: new CustomClusterRenderer()
      });
    
      const bounds = new google.maps.LatLngBounds(); // Reset bounds
    

      // Iterate through each operation and create a new marker
      fatalities.forEach(operation => {
        let icon = mapPinNeutral;
        if (operation.designation == "Anti-Treaty") icon = mapPinAnti;
        else if (operation.designation == "Pro-Treaty") icon = mapPinPro;
        else icon = mapPinNeutral;

        const marker = new google.maps.Marker({
          position: operation.position,
          title: operation.title,
          icon: icon
        });

        markers.push(marker);
        bounds.extend(marker.getPosition());

        marker.addListener('click', () => {
          const popup = document.getElementById("custom-popup");
          document.getElementById("popup-content").innerHTML = operation.info;
          popup.style.display = "block";
          scrollIntoViewIfNotVisible(popup);
        });
      });
          
      // Fit the map to the new bounds that include all markers
      map.fitBounds(bounds);
    
      // Reinitialize MarkerClusterer with the updated markers
      refreshMarkerCluster = new MarkerClusterer({
        map: map,
        markers: markers,
        renderer: new CustomClusterRenderer()
      });
      //refreshMarkerCluster();
    }   

    updateMarkers(fatalities);
    updateTable(fatalities);
  });
});


$("#map-close-btn").on("click", function() {

  document.getElementById("custom-popup").style.display = "none";
});

function scrollIntoViewIfNotVisible(target) {   
  if (target.getBoundingClientRect().top < 70) {
      target.scrollIntoView();
      scrollToTargetAdjusted(target);
  } 
}

function scrollToTargetAdjusted(element){
  var headerOffset = 137;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
  });
}

/* eslint-enable */